<template>
    <CompassMenu
        placement="top-start"
        trigger="click"
        custom-class="custom-menu-container"
        :disabled="disabled"
    >
        <CompassTooltip
            :content="$t.__(getExtensionOption(option).label)"
            placement="top"
            :delay="{ show: 0, hide: 1 }"
            :disabled="disabled"
        >
            <CompassIconButton
                :icon="getExtensionOption(option).icon"
                size="small"
                :disabled="disabled"
                :active="activeStyle(option)"
                show-dropdown
            />
        </CompassTooltip>
        <template #dropdown>
            <CompassMenuItem
                v-for="(size, indexSize) in allCustomSize"
                :key="indexSize"
                class="custom-menu-item"
                @click="getExtensionOption('Size').action(size)"
            >
                <span class="typographies-paragraph-small-regular"> {{ size }}px </span>
            </CompassMenuItem>
            <CompassMenuItem
                class="custom-menu-item"
                @click="getExtensionOption('UnSize').action()"
            >
                <span class="typographies-paragraph-small-regular">
                    {{ $t.__(getExtensionOption('UnSize').label) }}
                </span>
            </CompassMenuItem>
        </template>
    </CompassMenu>
</template>

<script>
import OptionsRichTextMixin from 'mixins/OptionsRichTextMixin';

export default {
    name: 'SizeRichText',
    mixins: [OptionsRichTextMixin],
    data() {
        return {
            allCustomSize: [7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 24, 28, 30],
        };
    },
};
</script>
